// eslint-disable-next-line no-restricted-imports
import { Setting as ISetting } from '@eih-netbroker/api-user-settings';
import { atom } from 'jotai';

export type SettingRaw = ISetting;

export type SettingId<USER_SETTING_ENUM> =
  | USER_SETTING_ENUM
  | {
      setting: USER_SETTING_ENUM;
      settingId: string | number;
    };

export const userSettingsCollectorAtom = atom<Array<SettingRaw>>([]);
